// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { Col, Form, Input, Row, Select } from "antd";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FIELD_LENGTH } from "../../../../utils/Constant";
import FormField from "../../../components/FormField";
import { ThematicDossierFormSectionProps } from "../../../types/ThematicDossierTypes";
import { KeywordInfoResponseDTO } from "../../../../api/backend-openapi";
import { useStore } from "effector-react";
import { KeywordStore } from "../../../../state/keyword/KeywordStore";
import { requestGetKeywords } from "../../../../state/keyword/KeywordEffects";

const ThematicDossierInputFormSection: React.FunctionComponent<ThematicDossierFormSectionProps> = (
  props: ThematicDossierFormSectionProps
) => {
  const { t } = useTranslation();

  const { editMode = true, /*createMode = false,*/ thematicDossier } = props;

  const keywordsStore: KeywordInfoResponseDTO[] | null = useStore(KeywordStore);

  useEffect(() => {
    // Rechargement des keywords pour être sûrs d'avoir le mapping s'ils ont changé depuis le démarrage de l'app
    requestGetKeywords();
  }, []);

  return (
    <>
      <Row>
        <Col xs={24} sm={thematicDossier?.publicationDate ? 12 : 16} lg={12}>
          <FormField
            labelName={t("thematic_dossier.name")}
            inputId="name"
            required={true}
            emptyErrorMessage={t("global.empty_error_field")}
            readOnly={!editMode}
            maxLength={FIELD_LENGTH.NAME}
          />
        </Col>
        {thematicDossier?.publicationDate && (
          <Col xs={24} sm={12}>
            <Row>
              <div style={{ height: 40 }} />
            </Row>
          </Col>
        )}
      </Row>
      <Row>
        <Col xs={24}>
          <Form.Item
            name="keywords"
            key="keywords"
            label={<span>{t("news.keywords.select")}</span>}
          >
            <Select
              id="keywords"
              placeholder={t("news.keywords.placeholder")}
              disabled={!editMode}
              mode="multiple"
              className="wdio-keywords"
              optionFilterProp="label"
              options={keywordsStore.map((keyword: KeywordInfoResponseDTO) => ({
                label: keyword.text,
                value: keyword.id
              }))}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <Form.Item
            name={"description"}
            label={<span>{t("thematic_dossier.description.label")}</span>}
          >
            <Input.TextArea
              id={"description"}
              placeholder={
                editMode ? t("thematic_dossier.description.placeholder") : ""
              }
              readOnly={!editMode}
              className={!editMode ? "readonly-textarea" : ""}
              maxLength={FIELD_LENGTH.DESCRIPTION}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

ThematicDossierInputFormSection.defaultProps = {
  editMode: true
};

export default ThematicDossierInputFormSection;
